export const TxtBtnToSubscribe = (currencySymbol, price = 0, currencyCode='MXN') => {
    return `Suscribirse por ${currencySymbol}${new Intl.NumberFormat('es-MX').format(price)} ${currencyCode}*`
}

